import React from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../context/CartContext';
export function NewIn() {
  const {
    addToCart
  } = useCart();
  const images = ['https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png', 'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png', 'https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png', 'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png'];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-742">
      <div className="max-w-[1800px] mx-auto" data-id="element-743">
        <header className="mb-20 text-center" data-id="element-744">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-745">
            Latest Arrivals
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-746">
            New In
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-747">
            The newest expressions of Djily Creations heritage. Fresh
            silhouettes and vibrant textiles just arrived.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-748">
          {images.map((img, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="group cursor-pointer" data-id="element-749">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-750">
                <img src={img} alt="New Arrival" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-751" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-752">
                  <button onClick={() => addToCart({
                id: `new-in-${i}`,
                name: `New Arrival ${i + 1}`,
                price: '$280.00',
                image: img,
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-753">
                    Add to Bag
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-start" data-id="element-754">
                <div data-id="element-755">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-756">
                    New Arrival {i + 1}
                  </h3>
                  <p className="text-sm font-light text-black/50" data-id="element-757">$280.00</p>
                </div>
                <button onClick={() => addToCart({
              id: `new-in-${i}`,
              name: `New Arrival ${i + 1}`,
              price: '$280.00',
              image: img,
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-758">
                  Add to Bag
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}